<template>
  <div style="width: 600px">
    <!-- <div class="top-back"></div> -->
    <div class="model-content">
      <div class="evaluateInvite">
        {{ feedBackConfig.evaluateInvite ? inviteTips : '' }}
      </div>
      <div v-if="isShowSubject">
        <div class="subject-list" v-for="(item, index) in subjectList" :key="index">
          <div :class="['label', index === 0 ? 'header-name': '']">{{item.subjectName}}</div>
          <star v-model="item.sorce"></star>
          <div class="sorceText">{{sorceTextFn(item.sorce)}}</div>
        </div>
      </div>
      <!-- <template v-if="feedBackConfig.opinionFeedback"> -->
      <template v-if="feedBackConfig.dissatisfiedCause && isShowReason && unsatisfyReason.length > 0">
        <div class="un-reason-tip">{{$t('dissatisfyReason')}}</div>
        <div class="reason-btn-page">
          <div class="reason-btn" v-for="item of unsatisfyReason"
               :class="{active:item.active}" @click="btnReason(item)" :title="item.text">{{item.text}}</div>
        </div>
      </template>
      <!-- 只要意见反馈开启后，无论满意/不满意都要展示输入框 -->
      <a-textarea v-if="feedBackConfig.opinionFeedback" class="reason-feed" v-model="feedback" :placeholder="feedPlaceholder"></a-textarea>
      <div class="solve-container" v-if="isSolveShow">
        <div class="solve-title">{{$t('questionIsSolve')}}</div>
        <div class="solve-result">
          <div @click="solveFn(true)" class="solve-result-list" :class="{active: isSolve}">
            <img v-if="isSolve" class="solve-icon" :src="require('@/assets/img/good-active.png')">
            <img v-else class="solve-icon" :src="require('@/assets/img/good.png')">
            {{$t('solved')}}
          </div>
          <div @click="solveFn(false)" class="solve-result-list" :class="{active: !isSolve}">
            <img v-if="!isSolve" class="solve-icon" :src="require('@/assets/img/bad-active.png')">
            <img v-else class="solve-icon" :src="require('@/assets/img/bad.png')">
            {{$t('unsolved')}}
          </div>
        </div>
      </div>
      <!-- <div class="evaluateThank" v-if="feedBackConfig.evaluateThank">{{evaluateThank}}</div> -->
      <div class="submite-container">
        <a-button style="margin-right: 20px" @click="closeDown">{{$t('CLOSE')}}</a-button>
        <a-button type="primary" :loading="btnLoading" @click="submitFeed">{{$t('OK')}}</a-button>
      </div>
    </div>
  </div>
</template>
<script>
import ajax from '@/ajax/axios-ajax.js'
import apis from '@/apis/index.js'
import star from '../common/star'
export default {
  data () {
    return {
      score: 5,
      formatScore: 0,
      feedback: '',
      isFeedback: false,
      feedPlaceholder: '',
      isReason: false,
      unsatisfyReason: [],
      inviteTips: this.$t('commentService'),
      isShowSatisfaction: false, // 是否显示满意度弹框
      evaluateThank: '',
      isShowThank: false,
      subjectList: [],
      isShowSubject: false,
      isSolve: true,
      isSolveShow: true,
      parmasLocation: {},
      feedBackConfig: {}, // 满意度权限
      configInfoBack: [],
      btnLoading: false,
      lang: 'zh'
    }
  },
  computed: {
    isShowReason () {
      if (this.subjectList.length === 0) {
        return false
      } else {
        let isTrue = false
        this.subjectList.forEach((ev) => {
          isTrue = isTrue || ev.sorce < 4
        })
        return isTrue
      }
    }
  },
  methods:{
    sorceTextFn (v) {
      if (+v === 1) {
        return this.$t('veryDissatisfied')
      } else if (+v === 2) {
        return this.$t('notSatisfied')
      } else if (+v === 3) {
        return this.$t('general')
      } else if (+v === 4) {
        return this.$t('satisfied')
      } else if (+v === 5) {
        return this.$t('verySatisfied')
      }
    },
    openUp (data = []) {
      this.isSolve = true
      this.feedback = ''
      let isSolveArr = data.filter((item) => {
        return item.configCode === 'solve.ask'
      })
      switch(isSolveArr[0].configInfo){
        case '1':
          this.isSolve = false
          break;
        case '0':
          this.isSolve = true
          break;
      }
      let defalultsArr = data.filter((item) => {
        return item.configCode === 'relative.value'
      })
      let defalultsObj = defalultsArr.length > 0 ? defalultsArr[0] : {}
      data.forEach((ev) => {
        if (ev.configCode === 'criterion') { // 评价标准
          this.formatScore = +ev.configValue
        } else if (ev.configCode === 'dissatisfied.cause') { // 不满意原因
          this.isReason = !!ev.enable
          if (ev.configValue) {
            this.unsatisfyReason = ev.configValue.split(',').map((v) => {
              return {
                active: false,
                text: v
              }
            })
          } else {
            this.unsatisfyReason = []
          }
        } else if (ev.configCode === 'opinion.feedback') { // 意见反馈框
          this.isFeedback = !!ev.enable
          this.feedPlaceholder = ev.configValue || ev.configInfo
        } else if (ev.configCode === 'evaluate.thank') { // 评价感谢语
          this.isShowThank = !!ev.enable
          this.evaluateThank = ev.configValue || ev.configInfo
        } else if (ev.configCode === 'evaluate.invite') { // 评价提示语
          this.inviteTips = ev.configValue || ev.configInfo
        } else if (ev.configCode === 'evaluate.subject') {
          this.isShowSubject = ev.enable === 1
          this.subjectList =ev.configInfo ? JSON.parse(ev.configInfo).map((item, index) => {
            let sorce = defalultsObj.configValue || defalultsObj.configInfo || 0
            return {
              subjectName: item.subjectName,
              sorce,
              subjectId: item.id
            }
          }) : []
        } else if (ev.configCode === 'solve.ask') {
          this.isSolveShow = ev.enable === 1
        }
      })
      this.isShowSatisfaction = true;
      setTimeout(() => {
        if ( document.getElementById('app')) {
          window.parent.postMessage({type: 'webcustomerPostMsg', action: 'bodyHeight', value: document.getElementById('app').offsetHeight}, '*')
        }
      }, 50)
    },
    solveFn (v) {
      this.isSolve = v
    },
    closeDown () {
      this.postMsg('close')
      // this.deleteKey_noticeEvaluate(this.serviceId)
      // this.isShowSatisfaction = false;
    },
    clickStar (i) {
      this.score = i;
    },
    btnReason (item) {
      item.active= !item.active
    },
    async getFeed(){
      this.score = 5
      this.feedback = ''
      let params = {
        tenantId: this.parmasLocation.tenantId ? this.parmasLocation.tenantId : '',
        visitorId: this.parmasLocation.visitorId
      }
      let res = await ajax.get(apis.satisfaction.configInfo, {params})
      if (res.success){
        this.openUp(res.data)
      }
    },
    async submitFeed () {
      let newReason = [];
      this.unsatisfyReason.forEach((ev)=>{
        if(ev.active){
          newReason.push(ev.text)
        }
      })
      let request = {
        satisfacte: {
          agentId: this.parmasLocation.agentId,
          tenantId: this.parmasLocation.tenantId,
          agentName: this.parmasLocation.agentName,
          isSolve: this.isSolveShow ? +this.isSolve : undefined,
          feedback: this.feedback,
          serviceId: this.parmasLocation.serviceId,
          serviceTime: this.parmasLocation.serviceTime,
          serviceTimeDesc: this.parmasLocation.serviceTimeDesc,
          groupId: this.parmasLocation.groupId,
          groupName: this.parmasLocation.groupName,
          visitorId: this.parmasLocation.visitorId,//访客编码
          visitorName: this.parmasLocation.visitorName,//访客姓名
          agentJobNum: this.parmasLocation.jobNum,
          unsatisfyReason:  this.isShowReason ? newReason.join(',') : ''
        },
        subjectList: this.subjectList,
        lang: this.lang
      }
      this.btnLoading = true
      let res = await ajax.post(apis.satisfaction.saveSatisfaction, request)
      if (res.success) {
        this.$message.success(res.message)
        this.postMsg('submitSuccess')
      } else {
        this.$message.error(res.message)
      }
      this.btnLoading = false
    },
    // 获取满意度配置
    getConfigInfo () {
      this.score = 5
      this.feedback = ''
      let params = {
        tenantId: this.parmasLocation.tenantId ? this.parmasLocation.tenantId : '',
        visitorId: this.parmasLocation.visitorId,
        lang: this.lang
      }
      ajax.get(apis.satisfaction.configInfo, {params}).then((res) => {
        if (res.success) {
          this.configInfoBack = JSON.parse(JSON.stringify(res.data || []))
          this.openUp(res.data)
          let obj = {}
          res.data.forEach((ev) => {
            if (ev.configCode == 'show.satisfaction') { // 满意度是否开启
              obj.isOpen = ev.enable == 1
            } else if (ev.configCode == 'end.evaluate') { // 会话结束主动邀评
              obj.endEvaluate = ev.enable == 1
            } else if (ev.configCode === 'result.remind') {  // 评价结果信息提醒
              obj.resultRemind = ev.enable == 1
            } else if (ev.configCode == 'evaluate.invite') { // 评价邀请语
              obj.evaluateInvite = ev.enable == 1
            } else if (ev.configCode === 'evaluate.thank') { // 评价感谢语
              obj.evaluateThank = ev.enable == 1
            } else if (ev.configCode == 'criterion') { // 评价标准设置
              obj.criterion = ev.enable == 1
            } else if (ev.configCode === 'dissatisfied.cause') { // 不满意原因设置
              obj.dissatisfiedCause = ev.enable == 1
            } else if (ev.configCode == 'opinion.feedback') { // 意见反馈框
              obj.opinionFeedback = ev.enable == 1
            }
          })
          this.feedBackConfig = obj
        }
      })
    },
    postMsg (v) {
      window.parent.postMessage({type: 'webcustomerPostMsg', action: v}, '*')
    },
    resetForm () {
      this.openUp(this.configInfoBack)
    },
    reloadForm () {
      this.getConfigInfo()
    },
    postMsgResetForm (event) {
      if (event.data && event.data.type === 'webcustomerPostMsg') {
        if (event.data.action === 'reset') {
          this.resetForm()
        } else if (event.data.action === 'reload') {
          this.reloadForm()
        }
      }
    }
  },
  created () {
    this.parmasLocation = this.$route.query
    this.lang = this.parmasLocation.lang ? this.parmasLocation.lang : this.lang
    this.$i18n.locale = this.lang
    this.getConfigInfo()
  },
  components: {
    star
  },
  mounted () {
    window.addEventListener('message', this.postMsgResetForm)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.postMsgResetForm)
  }
}
</script>
<style scoped lang="less">
  .header-name {
    font-weight: bold;
  }
  .top-back{
    height: 145px;
    background: top url("../../../assets/img/topBack-satifaction.png") no-repeat;
    background-size: 100% auto;
  }
  .model-content{
    padding: 18px 40px 40px 40px;
    line-height: 1;
  }
  .feed-back{
    width: 16rem;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 0.2rem;
    padding: 0.5rem;
    background-color: #fff;
    text-align: left;
    position: relative;
  }
  .evaluateInvite{
    color: #999;
    font-size: 14px;
    margin-bottom: 40px;
  }
  .solve-container{
    margin-top: 40px;
    .solve-title{
      color: #333;
      font-size: 14px;
    }
    .solve-result{
      display: flex;
      justify-content: space-around;
      margin: 20px auto;
      width: 350px;
    }
  }
  .solve-result-list{
    color: #bfbfbf;
    cursor: pointer;
    font-size: 20px;
    &.active{
      color: #222;
      .fa{
        color: #109cff;
      }
    }
  }


  .reason-feed{
    margin-top: 10px;
    height: 100px;
  }
  .satisfaction-text{
    line-height: 1.4;
    cursor: pointer;
    text-align: center;
    .radio-page{
      margin-right: 20px;
    }
  }
  .satisfaction-num{
    margin-top: 10px;
    cursor: pointer;
    text-align: center;
    .radio-page{
      margin-right: 40px;
    }

  }
  .subject-list{
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .label{
      width: 160px;
      color: #333333;
      font-size: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      word-wrap: break-word;
      word-break: break-all;
      margin-right: 8px;
      text-align: center;
      /*margin-bottom: 20px;*/
    }
    .sorceText{
      padding-left: 20px;
      color: #333;
      font-size: 14px;
    }
  }
  .un-reason-tip{
    font-size: 14px;
    color: #333
  }
  .reason-btn-page{
    margin-top: 20px;
    .reason-btn{
      cursor: pointer;
      width: 170px;
      height: 36px;
      border: 1px solid #ddd;
      text-align: center;
      line-height: 36px;
      display: inline-block;
      border-radius: 5px;
      margin-right: 10px;
      font-size: 14px;
      overflow: hidden;
      word-break: break-all;
      white-space: nowrap;
      text-overflow: ellipsis;
      &.active{
        border-color: #109cff;
        background-color: #d9efff;
      }
    }
  }
  .submite-container{
    margin-top: 40px;
    text-align: center;
  }
  .evaluateThank{
    margin-top: 20px;
    color: #999999;
  }
  .solve-icon{
    width: 26px;
    height: 26px;
  }
</style>
<style lang="less">
  .satisfaction-model {
    .ant-modal-content {
      overflow: hidden;
      border-radius: 20px;
    }
  }
</style>
